import React from 'react';

import clsx from 'classnames';
import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';

import _ from 'lodash';
import { ReadOnlyCard } from './RenewalComponents';

const P100ContactInformation = ({ data }: any) => {
  const classes = useStyles();

  return (
    <ReadOnlyCard>
      <Grid container>
        <Grid item md={12}>
          <div className="flex--spaced">
            <h3 className={clsx('contrast-text', classes.miniheading)}>
              Organization Contact
            </h3>
          </div>
        </Grid>
        <Grid item md={12} style={{ paddingBottom: '1.083rem' }}>
          <LeftColumn data={data} />
        </Grid>
      </Grid>
    </ReadOnlyCard>
  );
};

const LeftColumn = ({ data }: any) => {
  const classes = useStyles();

  return (
    <Grid item md={6} className={classes.border}>
      <Grid container direction="row">
        <Grid item md={6}>
          <span>Current Contact</span>
        </Grid>
        <Grid item md={2}>
          <span className={classes.textInfo}>
            {_.get(data, 'policyContactName', '-')}
          </span>
        </Grid>
      </Grid>
      <Grid container direction="row">
        <Grid item md={6}>
          <span>Current Contact Phone Number:</span>
        </Grid>
        <Grid item md={2}>
          <span className={classes.textInfo}>
            {_.get(data, 'policyContactPhone', '-')}
          </span>
        </Grid>
      </Grid>
      <Grid container direction="row">
        <Grid item md={6}>
          <span>Current Contact Email:</span>
        </Grid>
        <Grid item md={2} direction="column">
          <span className={classes.textInfo}>
            {_.get(data, 'policyContactEmail', '-')}
          </span>
        </Grid>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles(({ config, palette }) => ({
  border: {
    paddingLeft: '2.083rem',
  },
  textInfo: {
    color: palette.primary.contrastText,
  },
  listStyle: {
    listStyle: 'none',
    marginTop: '0rem',
    paddingLeft: '0rem',
  },
  miniheading: {
    fontWeight: config.weights.bold,
    fontSize: '2.083rem',
    paddingLeft: '2.083rem',
    marginBottom: '0.75rem',
    marginTop: '0.75rem',
  },
}));

export default P100ContactInformation;
